module.exports = __webpack_public_path__ + "img/00s_pack.6203868e.png";